<script>
import {defineComponent} from "vue";
import {trans} from "laravel-vue-i18n";

export default defineComponent({
    name: "DropDownButton",
    props: {
        id: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        header: {
            type: String,
            required: false
        },
        icon: {
            type: String,
            required: false
        },
        iconPosition: {
            type: String,
            default() {
                return 'left'
            }
        },
        dropdownCls: {
            type: String,
            default() {
                return ''
            }
        },
        hideIfNoOptions: {
            type: Boolean,
            default() {
                return false
            }
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        options: {
            type: Array | null,
            required: true
        },
        cls: {
            type: String,
            default() {
                return ''
            }
        },
        dropClass: {
            type: String,
            default() {
                return ''
            }
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        noArrow: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        trans,
        emitClick(option) {
            this.$emit('click', option)
        },
        getSlotNameByOption(option) {
            return option.name ?? typeof option === 'string' ? option : 'action'
        },
        getOptionTitle(option) {
            return option.title ?? option.name ?? (typeof option === 'string' ? option : 'action')
        }
    }
});
</script>

<template>
    <div :class="['dropdown', {'d-none': hideIfNoOptions && options.length === 0, 'no-arrow': noArrow}, dropdownCls]">
        <button class="btn collapsed dropdown-toggle align-items-center " :class="[cls, {'btn-icon-split': icon && text, 'no-arrow': noArrow}]"
                type="button"
                :disabled="disabled || loading"
                :id="'drop-btn-' + id" data-bs-toggle="dropdown" aria-expanded="false">
            <div v-if="loading && icon && iconPosition === 'left'" class="spinner-border spinner-border-sm"
                 role="status">
                <span class="sr-only"></span>
            </div>
            <i v-else-if="icon && iconPosition === 'left'" class="icon" :class="icon"></i>
            <slot name="text">
                <span v-if="text !== ''" class="text"> {{ text }}</span>
            </slot>
            <div v-if="loading && icon && iconPosition === 'right'" class="spinner-border spinner-border-sm"
                 role="status">
                <span class="sr-only"></span>
            </div>
            <i v-else-if="icon && iconPosition === 'right'" class="icon" :class="icon"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end" :class="dropClass" :aria-labelledby="'drop-btn-' + id">
            <li v-if="header"><h6 class="dropdown-header">{{ header }}:</h6></li>
            <li v-for="(option, index) in options" :key="index">
                <slot :name="getSlotNameByOption(option)" v-bind="option">
                    <a class="dropdown-item" role="button" @click="emitClick(option)">{{ getOptionTitle(option) }}</a>
                </slot>
                <slot name="divider">
                    <div v-if="index !== options.length - 1" class="dropdown-divider"></div>
                </slot>
            </li>
            <slot name="content"></slot>
        </ul>
    </div>
</template>
